import { MutationDefinition } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { MutationActionCreatorResult } from '@reduxjs/toolkit/dist/query/core/buildInitiate';
import { BaseQueryFn } from '@reduxjs/toolkit/dist/query/baseQueryTypes';

type DefaultDefinition = MutationDefinition<
  unknown,
  BaseQueryFn,
  string,
  unknown
>;

type SuccessfulMutation<Definition extends DefaultDefinition> = Exclude<
  Awaited<MutationActionCreatorResult<Definition>>,
  { error: unknown }
>;

export const isMutationSuccessful = <Definition extends DefaultDefinition>(
  result: Awaited<MutationActionCreatorResult<Definition>>,
): result is SuccessfulMutation<Definition> => 'data' in result;
